import axios from "axios";
import axiosUrl from "./axios.service";
import store from "../store/index";

const API_URL = axiosUrl.getAxiosUrl();

class FiltersService {
  async getDefaultFilters() {
    return await axios
      .get(API_URL + `grantsearchfilter/tags`, {
        params: {
          culture: "nl"
        }
      })
      .then(response => {
        store.commit("advancedSearch/updateFilterActivities", response.data);
        store.commit("advancedSearch/createLocationsOptions");
      });
  }

  async getAllPublicationStatuses() {
    return await axios
      .get(API_URL + "grantsearchfilter/getAllPublicationStatusesGroupOptions")
      .then(response => {
        store.commit(
          "advancedFilters/updatePublicationStatusesEnums",
          response.data
        );
      });
  }

  getSchemesForSelect(filter) {
    return axios
      .get(API_URL + "schemes/getFilteredSchemesForSelect", {
        params: {
          filter: filter
        }
      })
      .then(response => {
        store.commit("newsSearch/updateSchemesOptions", response.data);
      });
  }
}

export default new FiltersService();
